// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { BillStatusAndTypeFragmentDoc } from '../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type OtherBillCellQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OtherBillCellQuery = { __typename?: 'Query', projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, bills: Array<{ __typename?: 'Bill', dueDate?: Types.Scalars['Date']['input'] | null | undefined, billedInCents: number, paidInCents: number, id: string, name: string, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string } }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }> } };

export type OtherBillCell_ProjectItemFragment = { __typename?: 'ProjectItem', id: string, displayName: string, bills: Array<{ __typename?: 'Bill', dueDate?: Types.Scalars['Date']['input'] | null | undefined, billedInCents: number, paidInCents: number, id: string, name: string, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string } }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }> };

export const OtherBillCell_ProjectItemFragmentDoc = gql`
    fragment OtherBillCell_ProjectItem on ProjectItem {
  id
  displayName
  bills {
    ...Named
    dueDate
    billedInCents
    lineItems {
      id
      amountInCents
      projectItem {
        id
        displayName
      }
    }
    paidInCents
    ...BillStatusAndType
  }
}
    ${NamedFragmentDoc}
${BillStatusAndTypeFragmentDoc}`;
export const OtherBillCellDocument = gql`
    query OtherBillCell($id: ID!) {
  projectItem(id: $id) {
    ...OtherBillCell_ProjectItem
  }
}
    ${OtherBillCell_ProjectItemFragmentDoc}`;

/**
 * __useOtherBillCellQuery__
 *
 * To run a query within a React component, call `useOtherBillCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtherBillCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtherBillCellQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOtherBillCellQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OtherBillCellQuery, OtherBillCellQueryVariables> & ({ variables: OtherBillCellQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OtherBillCellQuery, OtherBillCellQueryVariables>(OtherBillCellDocument, options);
      }
export function useOtherBillCellLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OtherBillCellQuery, OtherBillCellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OtherBillCellQuery, OtherBillCellQueryVariables>(OtherBillCellDocument, options);
        }
// @ts-ignore
export function useOtherBillCellSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OtherBillCellQuery, OtherBillCellQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OtherBillCellQuery, OtherBillCellQueryVariables>;
export function useOtherBillCellSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OtherBillCellQuery, OtherBillCellQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OtherBillCellQuery | undefined, OtherBillCellQueryVariables>;
export function useOtherBillCellSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OtherBillCellQuery, OtherBillCellQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OtherBillCellQuery, OtherBillCellQueryVariables>(OtherBillCellDocument, options);
        }
export type OtherBillCellQueryHookResult = ReturnType<typeof useOtherBillCellQuery>;
export type OtherBillCellLazyQueryHookResult = ReturnType<typeof useOtherBillCellLazyQuery>;
export type OtherBillCellSuspenseQueryHookResult = ReturnType<typeof useOtherBillCellSuspenseQuery>;
export type OtherBillCellQueryResult = Apollo.QueryResult<OtherBillCellQuery, OtherBillCellQueryVariables>;